import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { ButtonDirective } from 'primeng/button';

export enum FailedToLoadModalAction {
  None = -1,
  GoToPipeline = 0,
  GoToUrla = 1,
  Close = 2,
}

@Component({
  templateUrl: './failed-to-load-modal.component.html',
  styleUrls: ['./failed-to-load-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class FailedToLoadModalComponent {
  private readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _config = inject(DynamicDialogConfig);

  modalData: { [key: string]: unknown };
  action = FailedToLoadModalAction.GoToPipeline;
  FailedToLoadModalAction = FailedToLoadModalAction;

  supportEmail = 'ClearSupport@cmgfi.com';
  subjectLine = 'Failed to load page correctly';
  hideMessage = false;
  hidePhone = false;
  hideHelpDesk = false;
  hideReload = false;

  constructor() {
    this.modalData = this._config.data;
    if (this.modalData?.action !== null && this.modalData?.action !== undefined) {
      this.hideMessage = this.modalData?.hideMessage ? (this.modalData?.hideMessage as boolean) : false;
      this.hideReload = this.modalData?.hideReload ? (this.modalData?.hideReload as boolean) : false;
      this.action = this._config.data?.action;
      if (this.modalData?.supportEmail) {
        this.supportEmail = this.modalData.supportEmail.toString();
        this.subjectLine = this.modalData?.subjectLine.toString();
        this.hidePhone = this.modalData?.hidePhone as boolean;
        this.hideHelpDesk = this.modalData?.hideHelpDesk as boolean;
      }
    }
  }

  goToPipeline(): void {
    this._dialogRef.close();
    window.location.href = '/pipeline';
  }

  goToUrla(): void {
    this._dialogRef.close();
    if (this.modalData?.fileDataId) {
      window.location.href = `/urla2/${this.modalData?.fileDataId}`;
    } else {
      this.goToPipeline();
    }
  }

  reloadPage(): void {
    location.reload();
  }

  cancel() {
    this._dialogRef.close();
  }
}
